var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPieChart = function SvgPieChart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 7.36c0-.75.61-1.36 1.36-1.36C29.9 6 36 12.1 36 19.64c0 .75-.61 1.36-1.36 1.36H33.2A13.64 13.64 0 1 1 21 8.8V7.35Zm0 4.18a10.96 10.96 0 0 0-1.36-.08A10.9 10.9 0 1 0 30.46 21h-8.1c-.75 0-1.36-.61-1.36-1.36v-8.1Zm2.73-2.73v9.46h9.46a10.91 10.91 0 0 0-9.46-9.46Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPieChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pieChart.395c0210535ba9ef7edcba14ad265272.svg";